import { FC, useMemo } from "react";

import { Column } from "@hdi-seguros/web-components.card";
import { SectionSummary } from "../../../../../../shared/components";

interface SummaryProps {
  data: Array<{ label: string; value: string | JSX.Element }>;
}

export const Summary: FC<SummaryProps> = ({ data }) => {
  const summaryInfo: Array<Column[]> = useMemo(
    () => [
      [
        ...data.map((element) => {
          return {
            ...element,
            columnSize: {
              sm: { span: 12 },
              xs: { span: 12 },
              md: { span: 10 },
              lg: { span: 7 },
            },
          };
        }),
      ],
    ],
    [data]
  );

  return <SectionSummary summaryInfo={summaryInfo} />;
};
